import "./Partner.css";
import React from 'react'
import partnerIcon from '../../../../Assets/Images/learnmorethumb.png'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation } from "swiper";
import partner1 from "../../../../Assets/Images/partner1.png"
import partner2 from "../../../../Assets/Images/partner2.png"
import partner3 from "../../../../Assets/Images/partner3.png"
import partner4 from "../../../../Assets/Images/partner4.png"
import partner5 from "../../../../Assets/Images/partner5.png"
import partner6 from "../../../../Assets/Images/partner6.png"
import partner7 from "../../../../Assets/Images/partner7.png"
import partner8 from "../../../../Assets/Images/partner10.png"
 
export default function Partner() {
    return (
        <div className="partner">
            <div className="container">
                <div className="partner-top">
                    <h3 className="partner-title">
                        International certifications For Quality & hygienic environment.
                    </h3>
                    <img src={partnerIcon} alt="" className="partner-icon" />
                    <p className="partner-text">
                        <p>  Organic Certification & Food Safety Certicifation </p> An ISC (Internation Standarts Certicifation) Approved by EURO UK.
                    </p>
                </div>
                <div className="partner-bottom">
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={10}
                        navigation={{ clickable: true }}

                        modules={[Navigation]}
                        breakpoints={{
                            300: {
                                slidesPerView: 3,
                                spaceBetween:20
                              },
                              400: {
                                slidesPerView: 3,
                                spaceBetween: 10
                              },
                              550: {
                                slidesPerView: 3,
                                spaceBetween: 20
                              },
                              770: {
                                slidesPerView: 4,
                                spaceBetween: 40
                              },
                              980: {
                                slidesPerView: 5,
                                spaceBetween: 20
                              }
                        }}
                        className="mySwiper"
                    >
                        <SwiperSlide>
                            <img className="partner-pic" src={partner1} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="partner-pic" src={partner2} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="partner-pic" src={partner3} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="partner-pic" src={partner4} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="partner-pic" src={partner5} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="partner-pic" src={partner6} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="partner-pic" src={partner7} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="partner-pic" src={partner8} alt="dsd" />
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </div>
    )
}
